import React from 'react';
import styled from 'styled-components';
import ButtonDefault, { ButtonPrimary } from '../../components/forms/Buttons';

interface ActionRowWrapperProps {
  marginRight?: string;
}

const ActionRowWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

const ActionItemWrapper = styled.div`
  margin-right: ${(props: ActionRowWrapperProps) => (props.marginRight ? props.marginRight : '0px')};
`;

interface ActionRowProps {
  id: string;
  clearDisabled?: boolean;
  saveDisabled?: boolean;
  onCancel: () => void;
  onSave: () => void;
}

const ActionRow: React.FC<ActionRowProps> = ({
  id,
  clearDisabled = false,
  saveDisabled = false,
  onCancel,
  onSave,
}) => (
    <ActionRowWrapper>
      <ActionItemWrapper marginRight="25px">
        <ButtonDefault
          id={`${id}CancelButton`}
          onClick={onCancel}
          disabled={clearDisabled}
          type="button"
        >
          CANCEL
        </ButtonDefault>
      </ActionItemWrapper>

      <ActionItemWrapper marginRight="25px">
        <ButtonPrimary
          id={`${id}SaveButton`}
          onClick={onSave}
          disabled={saveDisabled}
          type="submit"
        >
          SAVE
        </ButtonPrimary>
      </ActionItemWrapper>
    </ActionRowWrapper>
  );

export default ActionRow;
